<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-appointment-list modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>รายการนัดหมาย ({{ $AppUtility.displayOnlyDate(titleDate) }})</span>
                        </h4>

                        <button class="btn-close" @click="hide(true)"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="appointment" v-for="(appointmentItem, appointmentIndex) in appointmentList" :key="appointmentIndex">
                            <div class="accept" v-if="appointmentItem.status === 'accept'">
                                <div class="cover"></div>
                                <div class="stamp">
                                    <b-icon icon="check2-square"></b-icon>
                                    <button v-if="appointmentItem.jobNumber">ดูใบสั่งงาน</button>
                                </div>
                            </div>
                            <div class="tag">
                                <div class="time">
                                    <b-icon icon="clock"></b-icon> {{ appointmentItem.time }}
                                </div>

                                <div class="booking" v-if="appointmentItem.booking">
                                    <span>หมายเลขการจอง <strong>{{ appointmentItem.booking.bookingRef }}</strong></span>
                                </div>
                            </div>

                            <h4>{{ appointmentItem.topic }}</h4>

                            <div class="contact">
                                <div class="field">
                                    <b-icon icon="person"></b-icon> {{ appointmentItem.name }}
                                </div>
                                <div class="field">
                                    <b-icon icon="minecart-loaded"></b-icon> {{ appointmentItem.license }}
                                </div>
                                <div class="field">
                                    <b-icon icon="telephone"></b-icon> {{ appointmentItem.tel }}
                                </div>
                            </div>

                            <div class="product" v-if="appointmentItem.booking">
                                <div class="item">
                                    <label>สินค้าสั่งจอง ({{ appointmentItem.booking.channel }})</label>
                                </div>
                                <div class="item" v-for="(productItem, productIndex) in appointmentItem.booking.productList" :key="productIndex">
                                    <span class="sku text-nowrap" v-if="productItem.inventoryData.sku">SKU: {{ productItem.inventoryData.sku }}</span>
                                    <span>{{ productItem.productData.name }} <span class="qty">x {{ productItem.quantity }}</span></span>
                                </div>
                            </div>

                            <div class="operation" v-if="appointmentItem.status !== 'accept'">
                                <button class="btn btn-sm btn-green" @click="accept(appointmentItem)"><b-icon icon="check2"></b-icon> รับนัดแล้ว</button>
                                <button class="btn btn-sm btn-red" @click="cancel(appointmentItem, appointmentIndex)"><b-icon icon="x"></b-icon> ยกเลิก</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';
import ModelStockSyncData from '@/resources/models/StockSyncData';
import DBBooking from '@/database/Booking';
import DBStock from '@/database/Stock';

export default {
    data() {
        return {
            titleDate: '',
            isActive: false,
            appointmentList: []
        };
    },
    props: {
        isDisplay: Boolean,
        appointmentData: Object
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.titleDate = new Date(this.appointmentData.keyDate);
                this.loadAppointmentList();
            }
        }
    },
    methods: {
        hide(isReload) {
            this.$emit('hide', isReload);
        },
        accept(item) {
            this.$swal({
                title: 'ต้องปรับสถานะ?',
                text: 'โปรดยืนยันว่าต้องการปรับสถานะเป็นรับนัดหมาย',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    item.status = 'accept';
                    item.data.status = 'accept';

                    const data = {
                        keyDate: this.appointmentData.keyDate,
                        appointment: item.data
                    }

                    await DBBooking.save(data);
                    loader.hide();
                }
            });
        },
        cancel(item, index) {
            this.$swal({
                title: 'ต้องการยกเลิกนัดหมาย?',
                text: 'โปรดยืนยันว่าต้องการยกเลิกนัดหมาย',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    const data = {
                        keyDate: this.appointmentData.keyDate,
                        appointment: item.data
                    }

                    await DBBooking.delete(data);

                    // Return if stock is reserved
                    this.returnStockData(item);

                    // Remove from current appointment display
                    this.appointmentList.splice(index, 1);

                    if (this.appointmentList.length === 0) {
                        this.hide(true);
                    }

                    loader.hide();
                }
            });
        },
        async returnStockData(appointment) {
            if (appointment.booking) {
                for (const item of appointment.data.reserve.product) {
                    const syncData = ModelStockSyncData.data();
                    syncData.key = item.inventoryKey;
                    syncData.operand = DBStock.operandAction().return;
                    syncData.amount = item.quantity;

                    await DBStock.returnReserveData(syncData);
                }
            }
        },
        loadAppointmentList() {
            this.appointmentList = [];

            this.appointmentData.list.forEach((item) => {
                this.appointmentList.push({
                    time: item.appointmentTime,
                    topic: item.topic,
                    name: [ item.customerFirstName, item.customerLastName ].join(' '),
                    license: [ item.licensePlate, '(' + OptionLicensePlateProvince.service.getValueByKey(item.licensePlateProvince) + ')'].join(' '),
                    tel: item.tel,
                    type: item.reserve.bookingId ? 'service' : 'other',
                    status: item.status,
                    booking: item.reserve.bookingId ? {
                        bookingRef: item.reserve.bookingId,
                        channel: item.reserve.channel,
                        productList: item.reserve.product
                    } : null,
                    data: item
                });
            });
            
            this.appointmentList.sort((a, b) => {
                const x = a['time']; const y = b['time'];

                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.modal-appointment-list {
    max-width: 1000px;

    .appointment {
        position: relative;
        border: 1px solid $textLightestColor;
        padding: 20px;
        margin-top: 20px;

        &:first-child {
            margin-top: 0;
        }
        
        .accept {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            .cover {
                position: absolute;
                background: $contentColor;
                opacity: 0.6;
                top: -1px;
                left: -1px;
                right: -1px;
                bottom: -1px;
                z-index: 1;
            }

            .stamp {
                position: absolute;
                top: 15px;
                right: 10px;
                z-index: 2;

                .bi {
                    font-size: 32px;
                    color: #289b86;
                    display: block;
                    margin: 0 auto 15px;
                }

                button {
                    font-size: 13px;
                    padding: 5px 14px;
                    outline: none;
                    border: none;
                    background: $mainColor;
                }
            }
        }

        .operation {
            position: absolute;
            top: 5px;
            right: 5px;

            .btn + .btn {
                margin-left: 5px;
            }
        }

        .tag {
            position: absolute;
            top: -1px;
            left: 0;
            font-size: 12px;
            display: flex;
            align-items: center;
            padding-right: 150px;

            .time {
                margin-right: 20px;
                border: 1px solid $textLightestColor;
                border-left: none;
                background: $textLightestColor;
                padding: 4px 10px 3px;
                white-space: nowrap;

                .bi {
                    margin-right: 7px;
                    opacity: 0.7;
                }
            }

            .booking {
                span {
                    display: block;
                    font-size: 13px;

                    strong {
                        color: $thirdColor;
                        margin-left: 15px;
                    }
                }
            }
        }

        h4 {
            font-size: 18px;
            font-weight: bold;
            margin: 25px 0 10px;
            color: $textMainColor;
        }

        .contact {
            display: flex;
            align-items: center;
            opacity: 0.8;

            .field {
                font-size: 13px;
                margin-right: 15px;

                .bi {
                    margin-right: 5px;
                    opacity: 0.7;
                }
            }
        }

        .product {
            margin-top: 15px;
            padding: 15px;
            border: 1px dashed $textLightestColor;

            .item {
                display: flex;
                flex-direction: column;
                margin-bottom: 7px;

                &:last-child {
                    margin-bottom: 0;
                }

                label {
                    color: $textLighterColor;
                    font-weight: bold;
                    font-style: italic;
                    font-size: 14px;
                }

                span {
                    font-size: 13px;

                    &.sku {
                        font-size: 11px;
                        opacity: 0.75;
                    }

                    &.qty {
                        margin-left: 15px;
                    }
                }
            }
        }
    }
}
</style>